// React imports.
import React from "react";

//app imports
import {Assessment3VendorAssignedStatusEnum} from "../state";
import {Assessment3HHDataReceivedStatusEnum} from "../state";
import {Assessment3HHVendorsSelectedStatusEnum} from "../state";
import {Assessment3HHServedByVendorsProvidingDataStatusEnum} from "../state";
import {Assessment3RateOfReturnStatusEnum} from "../state";


const Assessment3VendorsAssignedTableRow = ({ state, fuel, rowClass }) => (
    <React.Fragment>
        <div className={"dwGridRow  col1 "+ rowClass}>{fuel.description}</div>
        {state.Assessment3Steps[state.CurrentAssessementStepIndex].showNumHouseholds === true &&
            <div className={"dwGridRow  col2 blue-background "+ rowClass}>
                <input id="numHouseholds" value={fuel.numHouseholds }
                    onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuel)} 
                    className="form-control "  />
            </div>
        }
        {(state.Assessment3Steps[state.CurrentAssessementStepIndex].showNumHouseholdsAssignedVendor === true
            && fuel.numHouseholds !== 0) &&
            <div className={"dwGridRow  col3 yellow-background "+ rowClass}>
                <input id="numHouseholdsAssignedVendor" value={fuel.numHouseholdsAssignedVendor }
                    onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuel)} 
                    className="form-control "  />
            </div>
        }

        {(state.Assessment3Steps[state.CurrentAssessementStepIndex].showNumHouseholdsAssignedVendor === true
          && fuel.numHouseholds === 0)&&

            <div className={"dwGridRow  col3 "+ rowClass}>
                N/A
            </div>
        }


        {(state.Assessment3Steps[state.CurrentAssessementStepIndex].showPercentHouseholdsAssignedVendor === true
            && fuel.numHouseholds !== 0) &&
          <React.Fragment>
              {(fuel.vendorAssignmentStatus ==Assessment3VendorAssignedStatusEnum.Over95NoIssues)
                  &&<div className={"dwGridRow  col4 green-background "+ rowClass}>{fuel.percentHouseholdsAssignedVendor}</div>
              }
              {( fuel.vendorAssignmentStatus ==Assessment3VendorAssignedStatusEnum.Under95NotMeetTarget)
                  &&<div className={"dwGridRow  col4 red-background "+ rowClass}>{fuel.percentHouseholdsAssignedVendor}</div>
              }
          </React.Fragment>
        }
        {(state.Assessment3Steps[state.CurrentAssessementStepIndex].showPercentHouseholdsAssignedVendor === true
          && fuel.numHouseholds === 0)&&

            <div className={"dwGridRow  col4 "+ rowClass}>
                N/A
            </div>
        }
        {(state.Assessment3Steps[state.CurrentAssessementStepIndex].showVendorAssignmentStatus === true
            && fuel.numHouseholds !== 0)  &&
            <React.Fragment>
                {(fuel.vendorAssignmentStatus ==Assessment3VendorAssignedStatusEnum.Over95NoIssues)
                    &&<div className={"dwGridRow  col5 green-background "+ rowClass}>
                          <span>
                              <strong>No Issue Flagged –</strong>
                              You have the fuel vendor and account number
                              on file for at least 95% of
                              your   {fuel.description}  households.
                          </span>
                      </div>
                }
                {( fuel.vendorAssignmentStatus ==Assessment3VendorAssignedStatusEnum.Under95NotMeetTarget)
                    &&<div className={"dwGridRow  col5 red-background "+ rowClass}>
                          <span>
                              <strong>Potential Issue –</strong>
                              You do not have a main heating vendor and
                              account number on file for at
                              least 95% of your   {fuel.description}  households.
                          </span>
                      </div>
                }
                {( fuel.numHouseholds=='')
                    &&<div className={"dwGridRow  col5 red-background "+ rowClass}>
                          <span>
                              <strong>Potential Issue –</strong>
                              You did not enter the number of   {fuel.description}  households
                              assisted.
                          </span>
                      </div>
                }
            </React.Fragment>
        }

        {(state.Assessment3Steps[state.CurrentAssessementStepIndex].showVendorAssignmentStatus === true
          && fuel.numHouseholds === 0)&&
            <div className={"dwGridRow  col5 "+ rowClass}>
                <strong>N/A – </strong>
                You indicated that you do not serve households
                that heat with  {fuel.description}.
            </div>
        }
    </React.Fragment>
);

export default Assessment3VendorsAssignedTableRow;
